var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgX = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1475 18.3524C19.2028 18.4039 19.2471 18.466 19.2778 18.535C19.3086 18.604 19.3251 18.6785 19.3264 18.754C19.3278 18.8295 19.3139 18.9045 19.2856 18.9746C19.2573 19.0446 19.2152 19.1082 19.1618 19.1617C19.1084 19.2151 19.0447 19.2572 18.9747 19.2855C18.9047 19.3138 18.8296 19.3277 18.7541 19.3263C18.6786 19.325 18.6041 19.3085 18.5351 19.2777C18.4661 19.247 18.404 19.2027 18.3525 19.1474L12 12.7958L5.64751 19.1474C5.54088 19.2467 5.39984 19.3008 5.25411 19.2983C5.10839 19.2957 4.96935 19.2367 4.86629 19.1336C4.76323 19.0305 4.7042 18.8915 4.70163 18.7458C4.69905 18.6 4.75315 18.459 4.85251 18.3524L11.2041 11.9999L4.85251 5.64738C4.75315 5.54075 4.69905 5.39972 4.70163 5.25399C4.7042 5.10827 4.76323 4.96923 4.86629 4.86617C4.96935 4.76311 5.10839 4.70407 5.25411 4.7015C5.39984 4.69893 5.54088 4.75302 5.64751 4.85238L12 11.2039L18.3525 4.85238C18.4591 4.75302 18.6002 4.69893 18.7459 4.7015C18.8916 4.70407 19.0307 4.76311 19.1337 4.86617C19.2368 4.96923 19.2958 5.10827 19.2984 5.25399C19.301 5.39972 19.2469 5.54075 19.1475 5.64738L12.7959 11.9999L19.1475 18.3524Z",
    fill: "#171719"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgX, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/X.50bcfce6.svg";
export { ForwardRef as ReactComponent };